import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [utilizador, setUtilizador] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const u = authAPI.utilizadorAtual();
    const token = localStorage.getItem('kialuga_token');
    if (u && token) setUtilizador(u);
    setCarregando(false);
  }, []);

  const login = (token, u) => {
    authAPI.guardarSessao(token, u);
    setUtilizador(u);
  };

  const logout = () => {
    authAPI.logout();
    setUtilizador(null);
  };

  // Atualiza dados do utilizador em memória e localStorage
  const actualizarUtilizador = (campos) => {
    const novo = { ...utilizador, ...campos };
    localStorage.setItem('kialuga_utilizador', JSON.stringify(novo));
    setUtilizador(novo);
  };

  return (
    <AuthContext.Provider value={{ utilizador, login, logout, carregando, actualizarUtilizador }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
